/** Body enviado ao PUT /authorized-devices/users/{userId}/bypass (GettelApi #552). */
export interface SetUserDeviceBypassApiRequest {
  bypassDeviceRestriction: boolean;
  bypassDeviceRestrictionUntil: string | null;
}

/** Resposta `data` do PUT bypass (GettelApi #552). */
export interface UserDeviceBypassApiResponse {
  bypass: boolean;
  until: string | null;
}

export function buildSetUserDeviceBypassApiRequest(
  enabled: boolean,
  untilUtc: string | null | undefined
): SetUserDeviceBypassApiRequest {
  return {
    bypassDeviceRestriction: enabled,
    bypassDeviceRestrictionUntil: enabled ? untilUtc ?? null : null,
  };
}
